import styled from "styled-components";
import COLORS from "styles/colors";

export const Container = styled.div`
  width: 100%;

  img {
    position: absolute;
    left: 140px;
  }
  .wrapper {
    margin: 10rem 9rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    position: relative;

    span {
      font-size: 1.4rem;
      line-height: 1.7rem;
      letter-spacing: 0.15em;
    }
    .title {
      font-size: 3.6rem;
      line-height: 4.5rem;
      margin: 12px 0;
    }
    p {
      font-size: 1.7rem;
      line-height: 2.8rem;
      max-width: 612px;
    }
    button {
      padding: 1.8rem 3rem;
      background: ${COLORS.primaryBackground};
      border-radius: 4px;
      color: ${COLORS.white};
      margin: 5rem 0;
    }
    .logo-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 15rem;
        height: auto;
        margin: 1.5rem 2rem;
        @media all and (max-width: 567px) {
          width: 10rem;
          margin: 1.5rem 1rem;
        }
      }
      .schoolLogo {
        width: 15%;
        height: fit-content;
        position: relative;
        left: 0;
        margin-right: 30px;
        margin-top: 25px;
        @media all and (max-width: 1024px) {
          width: 30%;
          margin-right: 10px;
        }
      }
    }
    @media all and (max-width: 567px) {
      margin: 5rem 2rem;
    }
  }
`;
